module.exports = __webpack_public_path__ + "arr_down.f4c3c807.png";